import apiClient from '../client';
import { User, ApiResponse } from '@/types';

export const usersApi = {
  getUsers: (params?: Record<string, any>) => 
    apiClient.get<ApiResponse<User[]>>('/users', { params }),
  
  getUser: (id: string) => 
    apiClient.get<ApiResponse<User>>(`/users/${id}`),
  
  createUser: (data: Partial<User>) => 
    apiClient.post<ApiResponse<User>>('/users', data),
  
  updateUser: (id: string, data: Partial<User>) => 
    apiClient.put<ApiResponse<User>>(`/users/${id}`, data),
  
  deleteUser: (id: string) => 
    apiClient.delete<ApiResponse<void>>(`/users/${id}`),
  
  inviteUser: (data: { email: string; role: string }) => 
    apiClient.post<ApiResponse<User>>('/users/invite', data),
  
  resendInvitation: (id: string) => 
    apiClient.post<ApiResponse<void>>(`/users/${id}/resend-invitation`),
  
  changePassword: (data: { currentPassword: string; newPassword: string }) => 
    apiClient.post<ApiResponse<void>>('/users/change-password', data),
};